/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const tagCandidateFileDataAttributeSchema = z.enum(['cv'])

export type TagCandidateFileDataAttributeSchema = z.infer<typeof tagCandidateFileDataAttributeSchema>
